module.exports = __webpack_public_path__ + "img/q3-8-active.af990590.png";